import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartLine24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconChartLine24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M8.78 10.22a.75.75 0 0 0-1.188.17l-3 5.5a.75.75 0 1 0 1.316.72l2.52-4.62 2.792 2.79a.75.75 0 0 0 1.238-.282l2.914-8.327 2.707 5.414a.75.75 0 0 0 1.342-.67l-3.5-7a.75.75 0 0 0-1.379.087l-3.106 8.874zM3.75 18.5a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5z"
            />
        </svg>
    );
}
export default memo(IconChartLine24);
